export default function countdownWidget(editor) {
  editor.DomComponents.addType('eb-countdown', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-countdown'
    },
    model: {
      defaults: {
        name: 'Countdown',
        tagName: 'div',
        droppable: false,
        attributes: {
          'data-gjs-type': 'eb-countdown',
          'data-target-date': new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 16),
        },
        style: {
          'display': 'flex',
          'justify-content': 'center',
          'gap': '20px',
          'padding': '30px 20px',
          'text-align': 'center',
        },
        components: `
          <div style="display:flex;flex-direction:column;align-items:center;">
            <span class="eb-cd-num" data-unit="days" style="font-size:48px;font-weight:700;color:#667eea;line-height:1;">07</span>
            <span style="font-size:12px;color:#666;text-transform:uppercase;letter-spacing:1px;margin-top:6px;">Days</span>
          </div>
          <div style="display:flex;flex-direction:column;align-items:center;">
            <span class="eb-cd-num" data-unit="hours" style="font-size:48px;font-weight:700;color:#667eea;line-height:1;">00</span>
            <span style="font-size:12px;color:#666;text-transform:uppercase;letter-spacing:1px;margin-top:6px;">Hours</span>
          </div>
          <div style="display:flex;flex-direction:column;align-items:center;">
            <span class="eb-cd-num" data-unit="minutes" style="font-size:48px;font-weight:700;color:#667eea;line-height:1;">00</span>
            <span style="font-size:12px;color:#666;text-transform:uppercase;letter-spacing:1px;margin-top:6px;">Minutes</span>
          </div>
          <div style="display:flex;flex-direction:column;align-items:center;">
            <span class="eb-cd-num" data-unit="seconds" style="font-size:48px;font-weight:700;color:#667eea;line-height:1;">00</span>
            <span style="font-size:12px;color:#666;text-transform:uppercase;letter-spacing:1px;margin-top:6px;">Seconds</span>
          </div>
        `,
        traits: [
          { type: 'datetime-local', name: 'data-target-date', label: 'Target Date', changeProp: true },
          { type: 'text', name: 'data-expired-text', label: 'Expired Message', placeholder: 'Event has started!' },
        ],
      },
      toHTML() {
        const attrs = this.getAttributes()
        const targetDate = attrs['data-target-date'] || ''
        const expiredText = attrs['data-expired-text'] || 'Event has started!'
        const style = this.getStyle()
        const styleStr = Object.entries(style).map(([k, v]) => `${k}:${v}`).join(';')
        return `<div data-gjs-type="eb-countdown" data-target-date="${targetDate}" style="${styleStr}">
          <div style="display:flex;flex-direction:column;align-items:center;">
            <span class="eb-cd-num" data-unit="days" style="font-size:48px;font-weight:700;color:#667eea;line-height:1;">00</span>
            <span style="font-size:12px;color:#666;text-transform:uppercase;letter-spacing:1px;margin-top:6px;">Days</span>
          </div>
          <div style="display:flex;flex-direction:column;align-items:center;">
            <span class="eb-cd-num" data-unit="hours" style="font-size:48px;font-weight:700;color:#667eea;line-height:1;">00</span>
            <span style="font-size:12px;color:#666;text-transform:uppercase;letter-spacing:1px;margin-top:6px;">Hours</span>
          </div>
          <div style="display:flex;flex-direction:column;align-items:center;">
            <span class="eb-cd-num" data-unit="minutes" style="font-size:48px;font-weight:700;color:#667eea;line-height:1;">00</span>
            <span style="font-size:12px;color:#666;text-transform:uppercase;letter-spacing:1px;margin-top:6px;">Minutes</span>
          </div>
          <div style="display:flex;flex-direction:column;align-items:center;">
            <span class="eb-cd-num" data-unit="seconds" style="font-size:48px;font-weight:700;color:#667eea;line-height:1;">00</span>
            <span style="font-size:12px;color:#666;text-transform:uppercase;letter-spacing:1px;margin-top:6px;">Seconds</span>
          </div>
          <script>
          (function(){var el=document.currentScript.parentElement;var td='${targetDate}';var et='${expiredText.replace(/'/g, "\\'")}';if(!td)return;var end=new Date(td).getTime();function u(){var n=Date.now(),d=end-n;if(d<=0){el.innerHTML='<div style="font-size:24px;font-weight:600;color:#667eea;padding:20px;">'+et+'</div>';return;}var nums=el.querySelectorAll('.eb-cd-num');nums.forEach(function(s){var unit=s.getAttribute('data-unit');var v=0;if(unit==='days')v=Math.floor(d/86400000);else if(unit==='hours')v=Math.floor((d%86400000)/3600000);else if(unit==='minutes')v=Math.floor((d%3600000)/60000);else if(unit==='seconds')v=Math.floor((d%60000)/1000);s.textContent=String(v).padStart(2,'0');});setTimeout(u,1000);}u();})();
          <\\/script>
        </div>`
      },
    },
  })

  editor.BlockManager.add('eb-countdown', {
    label: 'Countdown',
    category: 'General',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M12,20A7,7 0 0,1 5,13A7,7 0 0,1 12,6A7,7 0 0,1 19,13A7,7 0 0,1 12,20M12,4A9,9 0 0,0 3,13A9,9 0 0,0 12,22A9,9 0 0,0 21,13A9,9 0 0,0 12,4M12.5,8H11V14L15.75,16.85L16.5,15.62L12.5,13.25V8M7.88,3.39L6.6,1.86L2,5.71L3.29,7.24L7.88,3.39M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25L22,5.72Z"/></svg>',
    content: { type: 'eb-countdown' },
  })
}
